





















































































import {Component, PropSync, Watch} from "vue-property-decorator";
import { Action } from "vuex-class";
import { SelectWings, ToggleWings, InputWings } from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";
import BaseFilter from "@/components/Filter/BaseFilter";
import { CallCenterUserFilter } from "@/store/user_management/callcenter_users/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    SelectWings,
    ToggleWings,
    InputWings
  },
})
export default class CallCenterUsersFilter extends BaseFilter<CallCenterUserFilter> {
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync("show") is_show!: boolean;

  @Action("getPartners") actionGetPartners: any;
  @Action("getCallCenterUsers") actionGetItems: any;
  @Action("exportCallCenterUsers") actionExportItems: any;

  private statusesList = [1, 0];
  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.filtered();
    this.scroll();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  defaultFilter(): CallCenterUserFilter {
    return {
      id: undefined,
      email: undefined,
      name: undefined,
      partner: undefined,
      status: undefined,
      page_number: 1
    };
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Call center user",
        addititional_info: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetItems({...this.filter, is_ad_user: 0})
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  async export() {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "Call center user",
      addititional_info: getTranslatedParams(this.filter)
    }
    try {
      await this.actionExportItems(this.filter)
      await this.actionLog(this.logObject);
    } catch(error) {
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: CallCenterUserFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
